import React, { useMemo, useState } from "react";
import { FaBars } from "react-icons/fa";
import "../assets/css/TopHeader.css";
import { getAccountType, getAuthItem } from "../utils/authStorage";

const OFFICE_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/office-logo.png`;

function readJson(key) {
  try {
    const raw = getAuthItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function resolveBrand() {
  const accountType = getAccountType();
  const isClient = accountType === "client";
  const user = readJson("user");
  const client = readJson("client");

  if (isClient && client) {
    const logo =
      client.Logo_Url ||
      client.logo_url ||
      client.Company_Logo ||
      client.company_logo ||
      client.logo ||
      null;
    const name =
      client.Company_Name ||
      client.company_name ||
      client.Display_Name ||
      client.display_name ||
      client.name ||
      "";
    if (logo) return { type: "logo", src: logo, name: String(name || "Company").trim() };
    if (name) return { type: "name", name: String(name).trim() };
  }

  const companyLogo =
    user?.company_logo ||
    user?.Company_Logo ||
    user?.logo_url ||
    user?.Logo_Url ||
    null;
  const companyName =
    user?.company_name ||
    user?.Company_Name ||
    user?.organization_name ||
    "";

  if (companyLogo) {
    return {
      type: "logo",
      src: companyLogo,
      name: String(companyName || "Company").trim(),
    };
  }
  if (companyName && String(companyName).trim()) {
    return { type: "name", name: String(companyName).trim() };
  }

  return { type: "logo", src: OFFICE_LOGO_SRC, name: "Office" };
}

/**
 * Mobile header: brand on the left, nav toggle on the right.
 * Shows logo when available; falls back to name only (never both).
 */
function TopHeader({ onToggleSidebar }) {
  const brand = useMemo(() => resolveBrand(), []);
  const [logoFailed, setLogoFailed] = useState(false);

  if (!onToggleSidebar) {
    return null;
  }

  const showLogo = brand.type === "logo" && brand.src && !logoFailed;
  const showName = !showLogo;

  return (
    <div className="top-header top-header--content-chrome">
      <div className="header-content header-content--mobile-brand">
        <div className="header-brand" title={brand.name}>
          {showLogo ? (
            <img
              src={brand.src}
              alt={brand.name}
              className={`header-brand__logo${brand.src !== OFFICE_LOGO_SRC ? " header-brand__logo--company" : ""}`}
              onError={() => setLogoFailed(true)}
            />
          ) : null}
          {showName ? (
            <span className="header-brand__name">{brand.name || "Office"}</span>
          ) : null}
        </div>

        <div className="header-title-row header-title-row--end">
          {onToggleSidebar ? (
            <button
              type="button"
              className="sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle navigation menu"
            >
              <FaBars size={18} />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default TopHeader;
